<!-- Employee Update Form -->

<form (ngSubmit)="f.form.valid && UpdateEmployee()" #f="ngForm" *ngIf="emp.pkEmpId!=0">
    <button type="button" (click)="Test()"></button>
    <div class="form-group row mb-0">
        <label for="staticEmail" class="col-sm-4 col-form-label">Unique Employee ID</label>
        <div class="col-sm-8">
            <input type="text" class="form-control" [(ngModel)]="pkEmpId" name="EmpId" disabled>
        </div>
    </div>
    <div class="form-group row mb-0">
        <label for="inputtext" class="col-sm-4 col-form-label">First Name</label>
        <div class="col-sm-8">
            <input type="text" class="form-control" [(ngModel)]="FirstName" name="FirstName" required
                #firstName="ngModel">
            <span *ngIf="f.submitted && firstName.errors?.required" class="text-danger">Please enter First Name</span>
        </div>
    </div>
    <div class="form-group row mb-0">
        <label for="staticEmail" class="col-sm-4 col-form-label">Last Name</label>
        <div class="col-sm-8">
            <input type="text" class="form-control" [(ngModel)]="LastName" name="LastName" required #lastName="ngModel">
            <span *ngIf="f.submitted && lastName.errors?.required" class="text-danger">Please enter Last Name</span>
        </div>
    </div>
    <div class="form-group row mb-0">
        <label for="Gender" class="col-sm-4 col-form-label">Gender</label>
        <div class="col-sm-8">
            <div class="btn-group btn-group-toggle" ngbRadioGroup name="Gender" [(ngModel)]="Gender">
                <label ngbButtonLabel class="btn-outline-dark btn-sm">
                    <input ngbButton type="radio" value="Male" required> Male
                </label>
                <label ngbButtonLabel class="btn-outline-dark btn-sm">
                    <input ngbButton type="radio" value="Female" required> Female
                </label>
                <!-- <div class="text-danger" *ngIf="Genders.errors?.required">Gender is required</div> -->
            </div>
        </div>
    </div>
    <div class="form-group row mb-0">
        <label for="staticEmail" class="col-sm-4 col-form-label">Email ID</label>
        <div class="col-sm-8">
            <input type="text" class="form-control" [(ngModel)]="EmpEmail" name="EmpEmail" required #emailID="ngModel"
                pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$">
            <span *ngIf="f.submitted && emailID.errors?.required" class="text-danger">Please enter Email ID</span>
            <span *ngIf="f.submitted && emailID.errors?.pattern" class="text-danger">Invalid Email ID</span>
            <!-- <span *ngIf="emailID.touched && emailID.errors?.pattern" class="text-danger">Invalid Email ID</span> -->
        </div>
    </div>
    <!-- <div class="form-group row mb-0">
        <label for="staticEmail" class="col-sm-4 col-form-label">Email ID</label>
        <div class="col-sm-8">
            <input type="email" name="email" ngModel [email]="true" #emailIDnew="ngModel">
            <span *ngIf="emailIDnew.touched && emailIDnew.invalid" class="text-danger">Invalid Email ID</span>
        </div>
    </div> -->
    <div class="form-group row mb-0">
        <label for="inputtext" class="col-sm-4 col-form-label">Designation</label>
        <div class="col-sm-8">
            <input type="text" class="form-control" [(ngModel)]="Designation" name="Designation">
        </div>
    </div>
    <div class="form-group row mb-0">
        <label for="staticEmail" class="col-sm-4 col-form-label">Contact Number</label>
        <div class="col-sm-8">
            <input type="text" class="form-control" [(ngModel)]="ContactNumber" name="ContactNumber" required
                #contactNum="ngModel" pattern="[+][0-9]{12,14}">
            <span *ngIf="f.submitted && contactNum.errors?.required" class="text-danger">Please enter contact
                number</span>
            <span *ngIf="f.submitted && contactNum.errors?.pattern" class="text-danger">Invalid Contact Number</span>

        </div>
    </div>
    <div class="form-group row mb-0">
        <label class="col-sm-4 col-form-label">Casual Leave Balance</label>
        <div class="col-sm-8">
            <input type="text" class="form-control" [(ngModel)]="CasualLeaveBalance" name="CasualLeaveBalance" required
                #casualBalance="ngModel">
            <span *ngIf="f.submitted && casualBalance.errors?.required" class="text-danger">Please enter employee's
                starting Casual Balance</span>
        </div>
    </div>
    <div class="form-group row mb-0">
        <label class="col-sm-4 col-form-label">Annual Leave Balanace</label>
        <div class="col-sm-8">
            <input type="text" class="form-control" [(ngModel)]="AnnualLeaveBalance" name="AnnualLeaveBalance" required
                #annualBalance="ngModel">
            <span *ngIf="f.submitted && annualBalance.errors?.required" class="text-danger">Please enter Annual Leave
                Balance
            </span>
        </div>
    </div>
    <div class="form-group row mb-0">
        <label for="inputtext" class="col-sm-4 col-form-label">Clockify ID</label>
        <div class="col-sm-8">
            <input type="text" class="form-control" [(ngModel)]="ClockifyId" name="ClockifyId" disabled>
        </div>
    </div>
    <div class="form-group row mb-0">
        <label for="IsPermanent" class="col-sm-4 col-form-label">Is Employee Permanent?</label>
        <div class="col-sm-8">
            <!-- <div class="btn-group btn-group-toggle" data-toggle="buttons" ngbRadioGroup [(ngModel)]="IsPermanent"
                name="radioBasic">
                <label ngbButtonLabel class="btn btn-secondary active">
                    <input ngbButton type="radio" name="options" id="YesOption" [value]="true" checked> Yes
                </label>
                <label ngbButtonLabel class="btn btn-secondary">
                    <input ngbButton type="radio" name="options" id="NoOption" [value]="false"> No
                </label>
            </div>

            <label class="col-sm-4 col-form-label">Is Employee Permanent?</label> -->
            <div class="btn-group btn-group-toggle" ngbRadioGroup name="IsPermanent" [(ngModel)]="IsPermanent">
                <label ngbButtonLabel class="btn-outline-dark btn-sm">
                    <input ngbButton type="radio" [value]="true"> Yes
                </label>
                <label ngbButtonLabel class="btn-outline-dark btn-sm">
                    <input ngbButton type="radio" [value]="false"> No
                </label>
            </div>

            <!-- <div class="btn-group btn-group-toggle" ngbRadioGroup name="radioBasic" [(ngModel)]="Gender">
                <label ngbButtonLabel class="btn-outline-dark btn-sm">
                    <input ngbButton type="radio" value="Male"> Male
                </label>
                <label ngbButtonLabel class="btn-outline-dark btn-sm">
                    <input ngbButton type="radio" value="Female"> Female
                </label>
            </div> -->


        </div>
    </div>
    <div class="d-flex justify-content-end">
        <button type="submit" class="btn btn-outline-success">Update</button>
    </div>
</form>


<!-- Employee Add Form -->

<form (ngSubmit)="f.form.valid && AddEmployee()" #f="ngForm" *ngIf="emp.pkEmpId==0">
    <!-- <button type="button" (click)="Test()"></button> -->
    <div class="form-group row mb-0">
        <label for="staticEmail" class="col-sm-4 col-form-label">Unique Employee ID</label>
        <div class="col-sm-8">
            <input type="text" class="form-control" [(ngModel)]="pkEmpId" name="EmpId">
        </div>
    </div>
    <div class="form-group row mb-0">
        <label for="inputtext" class="col-sm-4 col-form-label">First Name</label>
        <div class="col-sm-8">
            <input type="text" class="form-control" [(ngModel)]="FirstName" name="FirstName" required
                #firstName="ngModel">
            <span *ngIf="f.submitted && firstName.errors?.required" class="text-danger">Please enter First Name</span>
        </div>
    </div>
    <div class="form-group row mb-0">
        <label for="staticEmail" class="col-sm-4 col-form-label">Last Name</label>
        <div class="col-sm-8">
            <input type="text" class="form-control" [(ngModel)]="LastName" name="LastName" required #lastName="ngModel">
            <span *ngIf="f.submitted && lastName.errors?.required" class="text-danger">Please enter Last Name</span>
        </div>
    </div>
    <div class="form-group row mb-0">
        <label for="Gender" class="col-sm-4 col-form-label">Gender</label>
        <div class="col-sm-8">
            <div class="btn-group btn-group-toggle" ngbRadioGroup name="Gender" [(ngModel)]="Gender">
                <label ngbButtonLabel class="btn-outline-dark btn-sm">
                    <input ngbButton type="radio" value="Male" ng-value="true"> Male
                </label>
                <label ngbButtonLabel class="btn-outline-dark btn-sm">
                    <input ngbButton type="radio" value="Female"> Female
                </label>
            </div>
        </div>
    </div>
    <div class="form-group row mb-0">
        <label for="staticEmail" class="col-sm-4 col-form-label">Email ID</label>
        <div class="col-sm-8">
            <input type="email" class="form-control" [(ngModel)]="EmpEmail" name="EmpEmail" required #emailID="ngModel"
                pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$">
            <span *ngIf="f.submitted && emailID.errors?.required" class="text-danger">Please enter Email ID</span>
            <span *ngIf="f.submitted && emailID.errors?.pattern" class="text-danger">Invalid Email ID</span>
            <!-- <span *ngIf="emailID.touched && emailID.errors?.pattern" class="text-danger">Invalid Email ID</span> -->
        </div>
    </div>
    <div class="form-group row mb-0">
        <label for="inputtext" class="col-sm-4 col-form-label">Designation</label>
        <div class="col-sm-8">
            <input type="text" class="form-control" [(ngModel)]="Designation" name="Designation">
        </div>
    </div>
    <div class="form-group row mb-0">
        <label for="staticEmail" class="col-sm-4 col-form-label">Contact Number</label>
        <div class="col-sm-8">
            <input type="text" class="form-control" [(ngModel)]="ContactNumber" name="ContactNumber" required
                #contactNum="ngModel" pattern="[+][0-9]{12,14}">
            <span *ngIf="f.submitted && contactNum.errors?.required" class="text-danger">Please enter contact
                number</span>
            <span *ngIf="f.submitted && contactNum.errors?.pattern" class="text-danger">Invalid Contact Number</span>

        </div>
    </div>
    <div class="form-group row mb-0">
        <label for="inputtext" class="col-sm-4 col-form-label">Casual Leave Balance</label>
        <div class="col-sm-8">
            <input type="text" class="form-control" [(ngModel)]="CasualLeaveBalance" name="CasualLeaveBalance" required
                #casualBalance="ngModel">
            <span *ngIf="f.submitted && casualBalance.errors?.required" class="text-danger">Please enter employee's
                starting Casual Balance</span>
        </div>
    </div>
    <div class="form-group row mb-0">
        <label for="staticEmail" class="col-sm-4 col-form-label">Annual Leave Balanace</label>
        <div class="col-sm-8">
            <input type="text" class="form-control" [(ngModel)]="AnnualLeaveBalance" name="AnnualLeaveBalance" required
                #annualBalance="ngModel">
            <span *ngIf="f.submitted && annualBalance.errors?.required" class="text-danger">Please enter Annual Leave
                Balance</span>
        </div>
    </div>
    <div class="form-group row mb-0">
        <label for="inputtext" class="col-sm-4 col-form-label">Clockify ID</label>
        <div class="col-sm-8">
            <input type="text" class="form-control" [(ngModel)]="ClockifyId" name="ClockifyId">
        </div>
    </div>
    <div class="form-group row mb-0">
        <label for="IsPermanent" class="col-sm-4 col-form-label">Is Employee Permanent?</label>
        <div class="col-sm-8">
            <div class="btn-group btn-group-toggle" ngbRadioGroup name="IsPermanent" [(ngModel)]="IsPermanent">
                <label ngbButtonLabel class="btn-outline-dark btn-sm">
                    <input ngbButton name="options" type="radio" [value]="true" autocomplete="off"> Yes
                </label>
                <label ngbButtonLabel class="btn-outline-dark btn-sm">
                    <input ngbButton name="options" type="radio" [value]="false" checked="checked" autocomplete="off"> No
                </label>
            </div>
        </div>
    </div>
    <div class="d-flex justify-content-end">
        <button type="submit" class="btn btn-outline-success">Add</button>
    </div>
</form>